import type { API, BlockAPI } from '@editorjs/editorjs';

export default class ClearFormattingTune {
  private api: API;
  private block: BlockAPI;

  static get isTune(): boolean {
    return true;
  }

  constructor({ api, block }: { api: API; block: BlockAPI }) {
    this.api = api;
    this.block = block;
  }

  render(): HTMLElement {
    const button = document.createElement('button');
    button.classList.add(this.api.styles.settingsButton);
    button.type = 'button';
    button.title = 'Clear all inline formatting (bold, italic, color, etc.)';
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"/>
      <path d="M22 11 11 22"/>
      <path d="M7 21 3 17"/>
    </svg>`;

    button.addEventListener('click', () => {
      this.clearFormatting();
    });

    return button;
  }

  private clearFormatting(): void {
    // Find the contentEditable element in the block
    const contentEditable = this.block.holder.querySelector<HTMLElement>('[contentEditable="true"]');

    if (contentEditable) {
      // Extract plain text (strips all HTML tags)
      const plainText = contentEditable.textContent || '';

      // Replace content with plain text
      contentEditable.innerHTML = plainText;

      // Trigger onChange to save the changes
      this.block.dispatchChange();
    }
  }

  // BlockTunes need a save method, but this tune doesn't store any data
  save(): object {
    return {};
  }
}
